import { render, staticRenderFns } from "./OptionPriority.vue?vue&type=template&id=69ba3bfc&scoped=true"
import script from "./OptionPriority.vue?vue&type=script&lang=js"
export * from "./OptionPriority.vue?vue&type=script&lang=js"
import style0 from "./OptionPriority.vue?vue&type=style&index=0&id=69ba3bfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ba3bfc",
  null
  
)

export default component.exports